var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "slider-wrapper" },
    [
      _vm.order == 0
        ? _c("div", { staticClass: "slider-wrapper__child img" }, [
            _c("img", { attrs: { src: "/static/images/child.png" } })
          ])
        : _vm._e(),
      _c("div", { staticClass: "slider-wrapper__numeric" }, [
        _c("div", { staticClass: "numeric" }, [
          _c(
            "ul",
            { staticClass: "numeric__list" },
            _vm._l(_vm.stages, function(stage) {
              return _c("li", { staticClass: "numeric__item" }, [
                _c("a", {
                  staticClass: "numeric__link center",
                  class: _vm.stageSelectorClass(stage),
                  attrs: { href: "#" },
                  domProps: { textContent: _vm._s(stage.order) },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.order = stage.order
                    }
                  }
                })
              ])
            }),
            0
          )
        ])
      ]),
      _vm.isMobile
        ? _c(
            "slider",
            {
              ref: "slider",
              staticClass:
                "slider-wrapper__slider slider-wrapper__slider--mobile",
              attrs: {
                options: {
                  slidesPerView: 1,
                  pagination: ".slider-wrapper__dots",
                  autoplay: 4000,
                  autoplayDisableOnInteraction: true
                }
              }
            },
            [
              _vm._l(_vm.stage.slides, function(slide) {
                return _c(
                  "swiper-slide",
                  {
                    key: slide.id,
                    staticClass: "slider",
                    style: {
                      "background-image":
                        "url(" + (slide.mobile_image || slide.image) + ")"
                    }
                  },
                  [
                    _c("div", { staticClass: "container" }, [
                      _c("div", { staticClass: "slider__wrap" }, [
                        _c("div", { staticClass: "slider__slider" }, [
                          _c("div", { staticClass: "slider__block" }, [
                            _c("div", { staticClass: "slider__unit" }, [
                              _c("h2", {
                                staticClass: "slider__title",
                                domProps: { textContent: _vm._s(slide.title) }
                              }),
                              _c("div", {
                                staticClass: "slider__text",
                                domProps: { textContent: _vm._s(slide.text) }
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              }),
              _c("div", {
                staticClass: "slider-wrapper__dots",
                attrs: { slot: "pagination" },
                slot: "pagination"
              })
            ],
            2
          )
        : _c(
            "slider",
            {
              ref: "slider",
              staticClass:
                "slider-wrapper__slider slider-wrapper__slider--desktop",
              attrs: {
                options: {
                  slidesPerView: 1,
                  pagination: ".slider-wrapper__dots",
                  autoplay: 4000,
                  autoplayDisableOnInteraction: true
                }
              }
            },
            [
              _vm._l(_vm.stage.slides, function(slide) {
                return _c(
                  "swiper-slide",
                  {
                    key: slide.id,
                    staticClass: "slider",
                    style: {
                      "background-image": "url(" + slide.image + ")"
                    }
                  },
                  [
                    _c("div", { staticClass: "container" }, [
                      _c("div", { staticClass: "slider__wrap" }, [
                        _c("div", { staticClass: "slider__slider" }, [
                          _c("div", { staticClass: "slider__block" }, [
                            _c("div", { staticClass: "slider__unit" }, [
                              _c("h2", {
                                staticClass: "slider__title",
                                domProps: { textContent: _vm._s(slide.title) }
                              }),
                              _c("div", {
                                staticClass: "slider__text",
                                domProps: { textContent: _vm._s(slide.text) }
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              }),
              _c("div", {
                staticClass: "slider-wrapper__dots",
                attrs: { slot: "pagination" },
                slot: "pagination"
              })
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ddc0534", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ddc0534","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/calendar/components/slider.vue
// module id = 250
// module chunks = 4